import { IMacroModel, MacroModel } from "@common/models";
import { HospitalService } from "@common/services";
import { NotificationStoreInstance } from "@common/stores";
import { flow, makeObservable, observable } from "mobx";

export class MacroStore {
    @observable macro: MacroModel | undefined;

    constructor() {
        makeObservable(this, undefined, { autoBind: true });
    }

    getMacro = flow(function* (this: MacroStore, macroId: number, macroTargetTypeId?: number) {
        this.macro = yield HospitalService.getMacro(macroId, macroTargetTypeId);
    });

    /**
     * Adds or update a macro
     * @param this current MacroStore reference
     * @param macro macro model to create
     */
    upsertMacro = flow(function* (this: MacroStore, macro: IMacroModel) {
        this.macro = macro.macroId === 0
            ? yield HospitalService.createMacro(macro)
                .then(NotificationStoreInstance.onSuccess("Communication Template added"))
                .catch(NotificationStoreInstance.onError("Failed to add Communication Template", macro))
            : yield HospitalService.updateMacro(macro)
                .then(NotificationStoreInstance.onSuccess("Communication Template updated"))
                .catch(NotificationStoreInstance.onError("Failed to update Communication Template", macro));
    });

    deleteMacro = flow(function* (this: MacroStore, macroId: number) {
        this.macro = yield HospitalService.deleteMacro(macroId);
    });
}
